import React, { useEffect } from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';

const PrintSpecsModal = ({ open, onClose, productRating, productMaterial, productInstallation, productMiscellaneous, product, handleClose, isPrintModalOpen,
    curveNumberURL, localized }) => {
    console.log(productRating)
    useEffect(() => {
        if (open) {
            const handleAfterPrint = () => {
                onClose(); 
            };

            window.addEventListener('afterprint', handleAfterPrint);

            const timeout = setTimeout(() => {
                window.print();
            }, 800); 

            return () => {
                clearTimeout(timeout);
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [open, onClose]);


    const renderSection = (title, data) => (
        data && (
            <>
                <Typography variant="h6" gutterBottom>{title}</Typography>
                {Object.entries(data).map(([key, value]) =>
                    value && key !== 'productId' && key !== 'sku' ? (
                        <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider', mb: 1 }}>
                            <Box sx={{ fontWeight: 'bold' }}>{localized[key].replace(/([A-Z])/g, ' $1').replace(/^0-9/g, '$& ').toUpperCase()}</Box>
                            <Box>{value}</Box>                            
                        </Box>
                    ) : null
                )}
            </>
        )
    );

    return (
        <>
        <style>
{`

    #printable-area, #printable-area * {
      visibility: visible;
    }

    #printable-area {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      max-width: 8.5in;
      height: auto;
      margin: 0 auto;
      padding: 1in;
      box-sizing: border-box;
      background: white;
      overflow: contain;
    }

    @page {
      size: 8.5in 11in;
      margin: 0;
    }
  }
`}
</style>
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogContent>
                <Box sx={{ padding: 4, maxWidth: 900, margin: '0 auto' }}> 
                    <Box sx={{ display: 'flex', gap: 4, mb: 4, flexWrap: 'wrap' }}>
                        <Box sx={{ flex: '1 1 300px', maxWidth: 300 }}>
                            <img
                                src={`${product.imageUrl}300x250px@1x/${product.sku}.jpg?q=80&x.template=y&crop=false`}
                                alt={product.name}
                                style={{ width: '100%', height: 'auto', borderRadius: 8 }}
                            />
                        </Box>
                        <Box sx={{ flex: '2 1 400px' }}>
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                                {product.name}
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom color="textSecondary">
                                SKU: {product.sku}
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                {product.description}
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={{ fontWeight: 'bold', borderBottom: '2px solid #ccc', pb: 1, mb: 3 }}
                        >
                            Specifications
                        </Typography>

                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {Object.getOwnPropertyNames(productRating).length > 0 && <Box sx={{ flex: '1 1 300px' }}>
                                    {renderSection(localized.ProductRating, productRating)}
                                </Box>}
                                {Object.getOwnPropertyNames(productMaterial).length > 0 && <Box sx={{ flex: '1 1 300px' }}>
                                    {renderSection(localized.ProductMaterial, productMaterial)}
                                </Box>}
                                {Object.getOwnPropertyNames(productInstallation).length > 0 && <Box sx={{ flex: '1 1 300px' }}>
                                    {renderSection(localized.ProductInstallation, productInstallation)}
                                </Box>}
                                {Object.getOwnPropertyNames(productMiscellaneous).length > 0 && <Box sx={{ flex: '1 1 300px' }}>
                                    {renderSection(localized.ProductMiscellaneous, productMiscellaneous)}
                                </Box>}
                            </Box>
                            <Box>
                            <Box>
                                    {curveNumberURL &&
                                        <>
                                            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                                                {localized.CurveUrl1}
                                            </Typography>
                                            <Box
                                                component="object"
                                                type="image/svg+xml"
                                                data={curveNumberURL}
                                                sx={{
                                                    border: 'none',
                                                    display: 'block',
                                                    mx: 'auto',
                                                }}
                                            />
                                        </>
                                    }
                                        </Box>
                            
                            </Box>
                    </Box>

                </Box>
            </DialogContent>
            </Dialog>
        </>
    );
};

export default PrintSpecsModal;
